import React from "react";

import { Filter, AutocompleteInput, ReferenceInput } from "react-admin";

const operationChoices = [
    { id: "add", name: "Add" },
    { id: "edit", name: "Edit" },
    { id: "remove", name: "Remove" },
    { id: "import", name: "Import" }
];

const entityChoices = [
    { id: "Attachment", name: "Attachment" },
    { id: "CustomizedSubphaseProgram", name: "Customized Subphase Program" },
    { id: "DoctorProfile", name: "Doctor profile" },
    { id: "FullProgram", name: "Full Program" },
    { id: "Patient", name: "Patient" },
    { id: "PatientNote", name: "Patient Note" },
    { id: "ScheduleProgram", name: "Schedule Program" },
    { id: "SessionSummary", name: "Session summary" },
    { id: "VerifiedEmail", name: "Unverified User" },
    { id: "User", name: "User" }
];

export const MainAuditFilter = props => (
    <Filter {...props}>
        <ReferenceInput source="doctor" reference="doctors" label="Clinician">
            <AutocompleteInput
                optionText={choice => `Clinician ${choice.first_name} ${choice.last_name}`}
            />
        </ReferenceInput>
        <AutocompleteInput
            source="entity"
            label="Entity Type"
            choices={entityChoices}
            translateChoice={false}
        />
        <AutocompleteInput
            source="operation"
            choices={operationChoices}
            translateChoice={false}
        />
    </Filter>
);

const adminTypeChoices = [
    { id: "m", name: "main-admin" },
    { id: "w", name: "doctor-admin" },
];

export const UserAccessFilter = props => (
    <Filter {...props}>
        <AutocompleteInput
            source="admin_type"
            choices={adminTypeChoices}
            translateChoice={false}
        />
    </Filter>
);
